import { api } from '@/shared/api/client'
import type { Me } from '@/features/auth/types'

export const meApi = {
  get: () => api.get<Me>('/me'),
}
